import styles from "./Carousel.module.css";

interface Props {
  gutter: number;
  itemWidth?: number;
  items: Array<any>;
}

export default function Carousel({ items, gutter, itemWidth }: Props) {
  const width = itemWidth * items.length;
  const halfGutter = gutter / 2;

  return (
    <div
      className={styles.Carousel}
      style={{
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 8,
        marginLeft: -gutter,
        marginRight: -gutter,
        paddingLeft: halfGutter,
      }}
    >
      <ul className={styles.list} style={{ width: width }}>
        {items.map((item, index) => (
          <li
            key={index}
            style={{
              paddingLeft: halfGutter,
              paddingRight: halfGutter,
            }}
          >
            <div
              className={styles.CarouselItem}
              style={{
                width: itemWidth ? itemWidth : "auto",
              }}
            >
              {item}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
